/**
 * CODE & SNIPPET SELLING THEME INTERACTIVE SCRIPT - "THE SNIPPET FLOW"
 */

document.addEventListener('DOMContentLoaded', () => {
  initCopyButtons();
  initCodeTabs();
  initSnippetSearch();
  initMobileNav();
});

/**
 * Mobile Navigation Drawer Toggle & Overlay
 */
function initMobileNav() {
  const toggleBtn = document.getElementById('mobile-menu-toggle-btn');
  const drawer = document.getElementById('mobile-nav-drawer');
  const closeBtn = document.getElementById('mobile-nav-close-btn');
  const backdrop = document.getElementById('mobile-nav-backdrop');

  if (toggleBtn && drawer) {
    function openNav() {
      if (!drawer) return;
      drawer.classList.add('active');
      if (backdrop) backdrop.classList.add('active');
      document.body?.classList.add('mobile-nav-open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeNav() {
      if (!drawer) return;
      drawer.classList.remove('active');
      if (backdrop) backdrop.classList.remove('active');
      document.body?.classList.remove('mobile-nav-open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    }

    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (drawer.classList.contains('active')) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeNav);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeNav);
    }

    drawer.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeNav);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1024 && drawer?.classList.contains('active')) {
        closeNav();
      }
    });
  }
}

/**
 * Copy to Clipboard Functionality
 */
function initCopyButtons() {
  document.querySelectorAll('[data-code-copy]').forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      const targetId = button.getAttribute('data-code-copy');
      let textToCopy = '';

      if (targetId) {
        const targetElem = document.getElementById(targetId);
        if (targetElem) {
          textToCopy = targetElem.textContent || '';
        }
      } else {
        const codeBlock = button.closest('.code-window-box')?.querySelector('.code-window-body');
        if (codeBlock) {
          textToCopy = codeBlock.textContent || '';
        }
      }

      if (textToCopy) {
        try {
          await navigator.clipboard.writeText(textToCopy);
          showToast('✓ Code copied to clipboard!');
          const originalText = button.innerHTML;
          button.innerHTML = '✓ Copied!';
          setTimeout(() => {
            button.innerHTML = originalText;
          }, 2000);
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
      }
    });
  });
}

/**
 * Code Tabs Switcher (Liquid, CSS, Preview)
 */
function initCodeTabs() {
  document.querySelectorAll('.code-window-box').forEach(box => {
    const tabs = box.querySelectorAll('.code-tab-btn');
    const panes = box.querySelectorAll('.code-tab-pane');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetPaneId = tab.getAttribute('data-tab');
        
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        panes.forEach(pane => {
          if (pane instanceof HTMLElement) {
            if (pane.id === targetPaneId) {
              pane.style.display = 'block';
            } else {
              pane.style.display = 'none';
            }
          }
        });
      });
    });
  });
}

/**
 * Snippet Category & Keyword Search Filter + Modal Trigger
 */
function initSnippetSearch() {
  const heroSearchInput = /** @type {HTMLInputElement | null} */ (document.getElementById('snippet-search-input'));
  const searchTriggerBtn = document.getElementById('header-search-trigger-btn');
  const searchModal = document.getElementById('code-search-modal');
  const searchModalInput = /** @type {HTMLInputElement | null} */ (document.getElementById('search-modal-input-field'));
  const searchModalClose = document.getElementById('search-modal-close-btn');
  const categoryButtons = document.querySelectorAll('[data-snippet-category]');
  const cards = document.querySelectorAll('.snippet-card-wrapper');

  let activeCategory = 'all';
  let searchQuery = '';

  function openSearchModal() {
    if (searchModal) {
      searchModal.classList.add('active');
      if (searchModalInput) {
        setTimeout(() => searchModalInput.focus(), 100);
      }
    }
  }

  function closeSearchModal() {
    if (searchModal) {
      searchModal.classList.remove('active');
    }
  }

  if (searchTriggerBtn) {
    searchTriggerBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openSearchModal();
    });
  }

  if (searchModalClose) {
    searchModalClose.addEventListener('click', closeSearchModal);
  }

  if (searchModal) {
    searchModal.addEventListener('click', (e) => {
      if (e.target === searchModal) {
        closeSearchModal();
      }
    });
  }

  // Global Keyboard Shortcuts (⌘K / Ctrl+K & ESC)
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      if (searchModal && searchModal.classList.contains('active')) {
        closeSearchModal();
      } else {
        openSearchModal();
      }
    } else if (e.key === 'Escape') {
      closeSearchModal();
    }
  });

  function filterSnippets() {
    if (!cards.length) return;
    cards.forEach(card => {
      if (!(card instanceof HTMLElement)) return;
      const cardTitle = card.getAttribute('data-title')?.toLowerCase() || card.querySelector('.snippet-card-title')?.textContent?.toLowerCase() || '';
      const cat = card.getAttribute('data-category')?.toLowerCase() || '';
      const tags = card.getAttribute('data-tags')?.toLowerCase() || '';
      const fullText = card.textContent?.toLowerCase() || '';

      const matchesCat = (activeCategory === 'all' || cat.includes(activeCategory) || fullText.includes(activeCategory));
      const matchesSearch = (!searchQuery || cardTitle.includes(searchQuery) || tags.includes(searchQuery) || fullText.includes(searchQuery));

      if (matchesCat && matchesSearch) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });
  }

  if (heroSearchInput) {
    heroSearchInput.addEventListener('input', () => {
      searchQuery = heroSearchInput.value.toLowerCase().trim();
      filterSnippets();
    });
  }

  if (searchModalInput) {
    searchModalInput.addEventListener('input', () => {
      searchQuery = searchModalInput.value.toLowerCase().trim();
      filterSnippets();
    });
  }

  categoryButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      categoryButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      activeCategory = (btn.getAttribute('data-snippet-category') || '').toLowerCase();
      filterSnippets();
    });
  });
}

/**
 * Show Toast Notification
 * @param {string} message
 */
function showToast(message) {
  let toast = document.getElementById('code-toast-elem');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'code-toast-elem';
    toast.className = 'code-toast';
    document.body.appendChild(toast);
  }
  toast.innerHTML = `<span>${message}</span>`;
  toast.classList.add('show');

  setTimeout(() => {
    toast.classList.remove('show');
  }, 2500);
}
